export default __webpack_public_path__ + "static/media/pepper-gray.db3790b7.svg";